import service from '@/plugins/service'

const mesApi = {}

const baseURL = '/mes'

mesApi.getUser = (id) => {
  return service({
    url: `${baseURL}/user`,
    method: 'get',
    params: {
      ID: id
    }
  })
}

mesApi.getCard = (code) => {
  return service({
    url: `${baseURL}/flowCard`,
    method: 'get',
    params: {
      code: code
    }
  })
}

mesApi.getProcesses = (code) => {
  return service({
    url: `${baseURL}/processes`,
    method: 'get',
    params: {
      code: code
    }
  })
}

mesApi.getHistoryProcesses = (code) => {
  return service({
    url: `${baseURL}/historyProcesses`,
    method: 'get',
    params: {
      code: code
    }
  })
}

mesApi.insertProcesses = (timeSecond, userCode, userName, userDepartment, cardCode, cardBatch, cardModel, cardprName, cardprCode, stepsName, stepsId, date) => {
  return service({
    url: `${baseURL}/insertprocesses`,
    method: 'post',
    data: {
      timeSecond: timeSecond,
      userCode: userCode,
      userName: userName,
      userDepartment: userDepartment,
      cardCode: cardCode,
      cardBatch: cardBatch,
      cardModel: cardModel,
      cardprName: cardprName,
      cardprCode: cardprCode,
      stepsName: stepsName,
      stepsId: stepsId,
      date: date
    }
  })
}

mesApi.call = (name, content) => {
  return service({
    url: `${baseURL}/call`,
    method: 'get',
    params: {
      name: name,
      content: content
    }
  })
}

mesApi.getList = (stockPosition) => {
  return service({
    url: `${baseURL}/material/listPos`,
    method: 'get',
    params: {
      stockPosition
    }
  })
}

mesApi.replenish = (stockPosition) => {
  return service({
    url: `${baseURL}/stock/replenishment/1/1000`,
    method: 'get',
    params: {
      stockPosition
    }
  })
}

export default mesApi
